import { OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput } from '__generated__/athena';

type Email = {
  address: {
    value: string;
  };
};

type Phone = {
  number: {
    value: string;
  };
  type: 'OTHER' | 'MOBILE' | 'HOME' | 'WORK';
};

export type Customer = {
  ccpaSaleOfDataOptOut: boolean;
  createdAt?: any | null;
  firstName: string;
  fullName?: string | null;
  isAgent: boolean;
  lastName: string;
  otherEmails: Array<Email>;
  otherPhoneNumbers: Array<Phone>;
  primaryEmail?: Email;
  primaryPhoneNumber?: Phone;
  uuid: string;
};

export type UseCurrentCustomerOptions = {
  onGetError?: (e: unknown) => void;
  onUpdateError?: (e: unknown) => void;
};

export type UseCurrentCustomerReturn = {
  customer: Customer | null;
  isLoading: boolean;
  isUpdating: boolean;
  isUserAuthenticated: boolean;
  update: (
    params: OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput,
  ) => Promise<Customer | undefined>;
};

export type UseCurrentCustomer = (options?: UseCurrentCustomerOptions) => UseCurrentCustomerReturn;

export const LOCALES = {
  ENGLISH: 'en-US',
  SPANISH: 'es',
} as const;

export type Locale = (typeof LOCALES)[keyof typeof LOCALES];

export type Coordinates = { lat: number; lng: number };

export type Prediction = google.maps.places.AutocompletePrediction & { coordinates: Coordinates };
